import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const StatesLayout = lazy(() => import('@/pages/states/layout'));
const StatesPage = lazy(() => import('@/pages/states'));
const CreateStatePage = lazy(() => import('@/pages/states/create'));
const StateSegmentLayout = lazy(() => import('@/pages/states/[stateCode]/layout'));
const UpdateStatePage = lazy(() => import('@/pages/states/[stateCode]/update'));
const ViewStatePage = lazy(() => import('@/pages/states/[stateCode]/view'));

export const stateRoutes: RouteConfig = {
  path: '/states',
  layout: DashboardLayout,
  children: [
    {
      path: '',
      layout: StatesLayout,
      children: [
        {
          path: '',
          element: StatesPage,
        },
        {
          path: '/create',
          element: CreateStatePage,
        },
        {
          path: '/:stateCode',
          layout: StateSegmentLayout,
          children: [
            {
              path: '/view',
              element: ViewStatePage,
            },
            {
              path: '/update',
              element: UpdateStatePage,
            },
          ],
        },
      ],
    },
  ],
};
